import { AuthConfig } from 'angular-oauth2-oidc';
import { AppConfigurationService } from '../core/services/AppConfigurationService';

export class AuthenticationConfig extends AuthConfig {
  changePasswordUri: string;

  constructor(appConfigurationService: AppConfigurationService) {
    super();

    this.tokenEndpoint = `${appConfigurationService.configuration.securityServer.baseEndpoint}/oauth2`;
    this.issuer = appConfigurationService.configuration.securityServer.oidcEndpoint;

    this.changePasswordUri = `${appConfigurationService.configuration.securityServer.baseEndpoint}/MyProfile/ChangePassword/`;

    this.redirectUri = `${window.location.origin}/`;
    this.silentRefreshRedirectUri = `${window.location.origin}/silent-refresh.html`;
    this.loginUrl = this.redirectUri;
    this.clientId = appConfigurationService.configuration.securityServer.clientId;
    this.logoutUrl = `${appConfigurationService.configuration.securityServer.baseEndpoint}/logout?client_id=${this.clientId}&logout_uri=${encodeURIComponent(this.redirectUri)}`;    this.scope = appConfigurationService.configuration.securityServer.scope;
    this.responseType = 'code';
    this.strictDiscoveryDocumentValidation = false;
    this.oidc = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/auth.config.ts